import { HttpClient } from '@angular/common/http';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var ErgFeedbackService = /** @class */ (function () {
    function ErgFeedbackService(http, bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
    }
    ErgFeedbackService.prototype.baseUrl = function () {
        return localStorage.getItem('userManagementUrl') || ConstantValues.userManagementApiUrl.userManagementUrl || '';
    };
    ErgFeedbackService.prototype.saveFeedback = function (payload) {
        return this.http.post(this.baseUrl() + ConstantValues.userManagementApiUrl.appFeedbackSave, payload, this.bpgCommonService.tokenizedHeader());
    };
    ErgFeedbackService.prototype.getFeedback = function () {
        return this.http.get(this.baseUrl() + ConstantValues.userManagementApiUrl.appFeedbackList, this.bpgCommonService.tokenizedHeader());
    };
    ErgFeedbackService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ErgFeedbackService_Factory() { return new ErgFeedbackService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: ErgFeedbackService, providedIn: "root" });
    return ErgFeedbackService;
}());
export { ErgFeedbackService };
